export class ApiResponse {
  public success: boolean = false
  public message: string = ''
  public messageExtra: string = ''
  public data: any
}
